<template>
    <v-app>
        <hotels-core-app-bar v-model="expandOnHover" />

        <hotels-core-drawer :expand-on-hover.sync="expandOnHover" />

        <hotels-core-view />

        <hotels-core-footer />
    </v-app>
</template>

<script>
    export default {
        name: 'HotelsIndex',

        /* >>> *************************************************************** / /* Components */
        components: {

            HotelsCoreAppBar: () => import('./components/core/AppBar'),
            HotelsCoreDrawer: () => import('@/components/core/Drawer'), // global
            HotelsCoreView: () => import('@/components/core/View'), // global
            HotelsCoreFooter: () => import('@/components/core/Footer') // global

        }, // eof components{}
        /* <<< ****************************************************************/


        /* >>> *************************************************************** / /* Data */
        data: () => ({

            expandOnHover: true

        })
        /* <<< ****************************************************************/
    };
</script>
